import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/footer',
    name: 'footer',
    component: () => import( '../components/Footer.vue')
  },
  {
    path: '/NetworkPublishing',
    name: 'NetworkPublishing',
    component: () => import( '../views/NetworkPublishing.vue')
  },
  {
    path: '/BlockChain',
    name: 'BlockChain',
    component: () => import('../views/BlockChain.vue'),
  },{
    path: '/Game',
    name: 'Game',
    component: () => import('../views/Game.vue'),
  },{
    path: '/AboutUs',
    name: 'AboutUs',
    component: () => import('../views/AboutUs.vue'),
  },
  {
    path: '/Music_art',
    name: 'Music_art',
    component: () => import('../views/Music_art.vue'),
  }, {
    path: '/news_more',
    name: 'news_more',
    component: () => import('../views/News_more.vue'),
  }
  , {
    path: '/information',
    name: 'information',
    component: () => import('../views/information.vue'),
  }
  , {
    path: '/NewsDetails',
    name: 'NewsDetails',
    component: () => import('../views/NewsDetails.vue'),
  }, {
    path: '/PublicationDetails',
    name: 'PublicationDetails',
    component: () => import('../views/PublicationDetails.vue'),
  }, {
    path: '/MusicDetails',
    name: 'MusicDetails',
    component: () => import('../views/MusicDetails.vue'),
  } ,{
    path: '/institution',
    name: 'institution',
    component: () => import('../views/Institution.vue'),
  }, {
    path: '/service',
    name: 'service',
    component: () => import('../views/service.vue'),
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    return { top: 0 }
  }
})

export default router
